import type { SupabaseAuthEnvConfig } from "@configs/custom-app-config-schema";
import { useAppStore } from "@hooks/useAppStore";
import { isDev } from "@memorang/constants/urls";
import { isWeb } from "@memorang/helpers/platform";
import { type SupabaseClient, createClient } from "@supabase/supabase-js";

let cachedClient: SupabaseClient | null = null;
let cachedKey: string | null = null;

const getSupabaseAuthEnvConfig = (): SupabaseAuthEnvConfig | null => {
	const supabase = useAppStore.getState().app?.keys?.supabase;
	if (!supabase) {
		return null;
	}
	return isDev ? supabase.dev : supabase.prod;
};

export const getSupabaseAuthClient = (): SupabaseClient => {
	const config = getSupabaseAuthEnvConfig();
	if (!config) {
		throw new Error(
			"Supabase auth config missing: app.keys.supabase is not set",
		);
	}

	if (cachedClient && cachedKey === config.anonKey) {
		return cachedClient;
	}

	cachedClient = createClient(config.url, config.anonKey, {
		auth: {
			persistSession: true,
			autoRefreshToken: true,
			detectSessionInUrl: false,
			// On web, default localStorage exposes JWTs to any injected script (XSS exfiltration).
			storage: isWeb ? window.sessionStorage : undefined,
		},
	});
	cachedKey = config.anonKey;
	return cachedClient;
};
